<div *ngIf="showModal" class="fixed inset-0 z-30 flex items-center justify-center container-modal">
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-black transition-opacity opacity-50"></div>
  <!-- Modal -->
  <div class="relative bg-white rounded-lg shadow dark:bg-gray-700 w-full">
    <!-- Modal header -->
    <div class="flex items-start justify-between p-4 rounded-t dark:border-gray-600 border-b">
      <h3 class="dark:text-white title-modal">
        {{ 'DASHBOARD.WORK SPACE.SIGNATURE' | translate }}
      </h3>
      <button
        type="button"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
        (click)="closeModal()"
      >
        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
          />
        </svg>
        <span class="sr-only">Close modal</span>
      </button>
    </div>
    <!-- Tabs -->
    <div class="dark:border-gray-600 tabs">
      <ng-container *ngFor="let tab of tabs; let idx = index">
        <div class="tab" [ngClass]="{ 'tab--active': activedTab === idx }" (click)="activeTab(idx)">
          <span>{{ tab.label | translate }}</span>
        </div>
      </ng-container>
    </div>
    <!-- Modal content -->
    <div class="p-6 space-y-6 text-center modal-content">
      <!-- Write signature-->
      <ng-container *ngIf="activedTab === 0">
        <canvas id="textCanvas" width="auto" height="130" style="margin: 0; padding: 0; vertical-align: top"></canvas>
        <input type="text" class="input-signature w-full" [(ngModel)]="signatureText" id="inputSignature" />
      </ng-container>
      <!--Draw signature -->
      <ng-container *ngIf="activedTab === 1">
        <app-signature
          (data)="drawSignature($event)"
          [show]="true"
          [getSignature]="getSignature"
          class="w-full"
        ></app-signature>
      </ng-container>
      <!-- Upload image signature-->
      <ng-container *ngIf="activedTab === 2">
        <app-system-input-file
          class="mb-3 h-[300px] w-full"
          textAccept="Max. File Size: 1MB"
          accept=".png,.jpg,.jpeg"
          [errorMsg]="errorUploadMsg"
          (file)="onFileSelected($event)"
          *ngIf="signatureUpload === ''"
        ></app-system-input-file>
        <div
          *ngIf="signatureUpload !== ''"
          class="bg-gray-50 border-2 border-dashed border-gray-300 cursor-pointer flex flex-col h-64 h-[300px] hover:bg-gray-100 items-center justify-center mb-3 rounded-lg w-full relative img-uploaded-container"
        >
          <img [src]="signatureUpload" alt="Signature" class="img-uploaded-container__img" />
          <app-system-icon
            iconName="trash-bin"
            (click)="signatureUpload = ''"
            class="absolute right-2 top-2 text-red-500 cursor-pointer img-uploaded-container__icon"
          ></app-system-icon>
        </div>
      </ng-container>
    </div>
    <!-- Modal footer -->
    <div class="flex items-center p-6 space-x-2 border-gray-200 rounded-b dark:border-gray-600 border-t">
      <div class="flex w-full flex-row flex-wrap justify-between">
        <button type="button" systemButtonOutline buttonType="secondary" (click)="closeModal()">
          {{ 'DASHBOARD.WORK SPACE.CANCEL' | translate }}
        </button>
        <button systemButton buttonType="primary" (click)="sendData()">
          {{ 'DASHBOARD.WORK SPACE.ACCEPT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Signature container to context -->
<img src="" alt="Signature container" id="signatureContainer" style="display: none" />
